import AMap from './AMap';
import POIPicker from './components/poiPicker';

export default AMap;
export {
    POIPicker
}